import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from './ui/card';
import { CheckCircle2 } from 'lucide-react';

const Outcomes = () => {
  const { t } = useLanguage();

  const outcomeImages = [
    '/images/outcome/outcome-1.png',
    '/images/outcome/outcome-2.png',
    '/images/outcome/outcome-3.png'
  ];

  return (
    <section className="py-20 medical-section-bg" style={{ backgroundImage: `url(https://images.pexels.com/photos/3768131/pexels-photo-3768131.jpeg)` }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
            {t.outcomes.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t.outcomes.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {t.outcomes.items.map((outcome, index) => (
            <Card 
              key={index}
              className="card-hover border-none shadow-lg"
              style={{ animationDelay: `${index * 0.1}s`, borderRadius: '16px' }}
            >
              <CardContent className="p-6">
                <div className="h-48 rounded-xl overflow-hidden mb-6">
                  <img 
                    src={outcomeImages[index]}
                    alt={outcome.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                <h3 className="text-2xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
                  {outcome.title}
                </h3>

                <ul className="space-y-3">
                  {outcome.bullets.map((bullet, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <CheckCircle2 size={20} className="mt-0.5 flex-shrink-0" style={{ color: '#2D4A8F' }} />
                      <span className="text-gray-700">{bullet}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Outcomes;
